/**
 * Formattazione monetaria condivisa (convenzione italiana): "1.234,56 €".
 *
 * Gli importi sono SEMPRE in centesimi interi (come nel backend). Non usare per
 * i calcoli: solo per la visualizzazione. Il totale autorevole arriva dal backend.
 */
export function formatEuro(cents: number | null | undefined): string {
  return new Intl.NumberFormat("it-IT", {
    style: "currency",
    currency: "EUR",
  }).format((cents ?? 0) / 100);
}
